import {MarketerTrackingRepositoryImpl} from '../repository/MarketerTrackingRepositoryImpl';
import type {WorkSession} from '../models/session.model';

export class GetSessionDetailsUseCase {
  private readonly repository = new MarketerTrackingRepositoryImpl();

  async execute (sessionId: number | string): Promise<WorkSession> {
    return this.repository.getSessionDetails(sessionId);
  }
}
